import axios from 'axios'
import {
  FALLBACK_ERROR_MESSAGE,
  NETWORK_ERROR_MESSAGE,
  resolveHttpErrorMessage,
} from '@/errors/http-error-messages'

export class AppError extends Error {
  userMessage: string
  statusCode: number | null
  originalError: unknown

  constructor(
    userMessage: string,
    statusCode: number | null,
    originalError: unknown,
  ) {
    super(userMessage)
    this.name = 'AppError'
    this.userMessage = userMessage
    this.statusCode = statusCode
    this.originalError = originalError
  }
}

export function toAppError(error: unknown): AppError {
  if (error instanceof AppError) {
    return error
  }

  if (axios.isAxiosError(error)) {
    const statusCode = error.response?.status ?? null
    const userMessage =
      statusCode === null
        ? NETWORK_ERROR_MESSAGE
        : resolveHttpErrorMessage(statusCode)
    return new AppError(userMessage, statusCode, error)
  }

  return new AppError(FALLBACK_ERROR_MESSAGE, null, error)
}
